export const CHART_COLORS = ['#D4870A', '#C0392B', '#6B8E23', '#8B7355', '#E8A020', '#5B8C5A'];
export const TOOLTIP_STYLE = { fontSize: 11, fontFamily: 'Jost', borderRadius: 8, border: '1px solid #F5E6CC' };
export const colorAt = (i) => CHART_COLORS[i % CHART_COLORS.length];
export const PANEL = 'bg-white rounded-lg border border-saffron-100/50 shadow-card-lift p-5';
